export enum FeatureType {
    Notices = 0,
    Draws = 1,
    HMDARequeue = 2,
    Inspections = 3,
    Experience = 4,
    Watchlists = 5,
    BusinessAndPeopleHierarchy = 6,
    BPHierarchyPhase1 = 7,
    BPHierarchyPhase2 = 8,
    BPHierarchyPhase3 = 9,
    ApplyV2 = 10,
    ApplyV2Applications = 11,
    GeneralContractor = 12,
    BusinessProfileWizard = 14,
}
